<template>
  <ModalRoot :closeByClickingOutside="true" @close="$emit('close')" :title="title">
    <div class="modal-dialog__content service-details-modal">
      <table>
        <thead>
          <tr>         
            <th />
            <th class="big-font"><span v-html="headlines.standard"/></th>
            <th><span v-html="headlines.standardPlus"/></th>
            <th class="width-stop">{{ headlines.sport }}</th>
            <th>{{ headlines.cancellationCostLow }}</th>
            <th>{{ headlines.cancellationCostHigh }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="small-padding">{{ leftSideTitles.medicalCost }}</td>
            <td><p>{{ content.highPrice }}<br><span class="small-font" v-html="content.priceExtended"/></p></td>
            <td><p>{{ content.highestPrice }}<br><span class="small-font" v-html="content.priceExtended"/></p></td>
            <td><p>{{ content.highPrice }}<br><span class="small-font" v-html="content.priceExtended"/></p></td>
            <td class="full-colum-content" rowspan="7">{{ content.cancellationCostLow }}</td>
            <td class="full-colum-content" rowspan="7">{{ content.cancellationCostHigh }}</td>
          </tr>
          <tr>
            <td class="big-padding"><span v-html="leftSideTitles.helpInTrip">{{ blank }}</span><span class="blue-font">{{ options.standard }}</span></td>
            <td>{{ content.highPrice }}</td>
            <td>{{ blank }}</td>
            <td>{{ content.highPrice }}</td>
          </tr>
          <tr>
            <td class="big-padding"><span v-html="leftSideTitles.helpInTrip">{{ blank }}</span><span class="blue-font">{{ options.extended }}</span></td>
            <td>{{ blank }}</td>
            <td>{{ content.highPrice }}</td>
            <td>{{ blank }}</td>
          </tr>
          <tr>
            <td class="average-padding">{{ leftSideTitles.luggage }}</td>
            <td>{{ content.lowestPrice }}</td>
            <td>{{ content.lowestPrice }}</td>
            <td>{{ content.lowestPrice }}</td>
          </tr>
          <tr>
            <td class="small-padding">{{ leftSideTitles.normalConsequences }}</td>
            <td>{{ content.lowPrice }}</td>
            <td>{{ content.middlePrice }}</td>
            <td>{{ content.lowPrice }}</td>
          </tr>
          <tr>
            <td class="small-padding">{{ leftSideTitles.specialConsequences }}</td>
            <td><Icon class="vaildCheckIcon" icon="form-valid-check" /></td>
            <td><Icon class="vaildCheckIcon" icon="form-valid-check" /></td>
            <td><Icon class="vaildCheckIcon" icon="form-valid-check" /></td>
          </tr>
          <tr>
            <td class="small-padding">{{ leftSideTitles.sportConsequences }}</td>
            <td>{{ blank }}</td>
            <td>{{ blank }}</td>
            <td><Icon class="vaildCheckIcon" icon="form-valid-check" /></td>
          </tr>
          <tr v-if="footerButton">
            <td class="clean-row" colspan="6">
              <div class="flexibility">
                <button class="service-details-modal__button" @click="$emit('close')">{{ buttonText }}</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ModalRoot>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'
import ModalRoot from '@/components/ModalRoot'

@Component({
  components: {
    ModalRoot,
    Icon,
  },
  props: {
    data: {
      type: Array,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    footerButton: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
})
export default class AdditionalServicesDetailsModal extends Vue {
  blank = ''

  headlines = { 
    standard: 'standard <br> w cenie',
    standardPlus: 'standard <br> plus',
    sport: 'sporty wysokiego ryzyka',
    cancellationCostLow: 'od kosztów rezygnacji 3%',
    cancellationCostHigh: 'od kosztów rezygnacji 9%',
  }

  leftSideTitles = {
    medicalCost: 'koszty leczenia, ratownictwa i transportu',
    helpInTrip: 'pomoc w podróży <br> w wersji',
    luggage: 'bagaż podróżny',
    normalConsequences: 'od następstw nieszczęśliwych wypadków',
    specialConsequences: 'Od następstw uprawiania turystyki kwalifikowanej',
    sportConsequences: 'Od następstw uprawiania sportów wysokiego ryzyka',
  }

  options = {
    standard: ' standard',
    extended: ' rozszerzonej',
  }

  content = {
    lowestPrice: '300 EUR',
    lowPrice: '3.000 EUR',
    middlePrice: '5.000 EUR',
    highPrice: '15.000 EUR',
    highestPrice: '65.000 EUR',
    priceExtended: 'w tym ratownictwo<br>5.000 EUR',

    cancellationCostLow: 'Ubezpieczenie KOSZTÓW REZYGNACJI i PRZERWANIA UCZESTNICTWA W IMPREZIE TURYSTYCZNEJ, zapewniające zwrot kosztów rezygnacji z imprezy turystycznej oraz przerwania uczestnictwa w imprezie',
    cancellationCostHigh: 'Ubezpieczenie KOSZTÓW REZYGNACJI Z IMPREZY TURYSTYCZNEJ rozszerzone o ryzyko chorób przewlekłych, zapewniające zwrot kosztów rezygnacji z imprezy turystycznej oraz przerwania uczestnictwa w imprezie dla osób, które chorują na choroby przewlekłe.', 
  }

  buttonText = 'wróć do ubezpieczeń'

}
</script>

<style lang="scss" scoped>

.service-details-modal {
  padding: 28px 30px 30px;
  overflow-x: scroll;

  @include media(tablet) {
    overflow-x: auto;
  }

  table {
    width: 970px;
    border-collapse: collapse; 
  }
  
  tbody {
    border-top: 2px solid #005CA9;
    height: 471px;
  }
  
  th {
    text-transform: uppercase;
    font-family: "Gotham";
    color: #005CA9;
    font-size: 0.99em;
    text-align: center;
    line-height: 1.1em;
  }
  
  th:nth-child(1) {
    text-align: left;
    padding-left: 0;
  }

  td {
    border: 1px solid #ADADAD;
    border-left: none;
    text-align: center;
    vertical-align: center;
    color: #535353;
    font-size: 16px;
    font-family: 'Gotham';
    font-weight: 500;
    line-height: 15px 

  }

  td:nth-child(1) {
    text-align: left;
    font-size: 12px;
    font-family: 'Gotham';
    font-weight: 500; 
    text-transform: uppercase;
    padding-left: 0;
    padding-right: 10px;
    width: 190px;
  }

  &__button {
    margin-top: 35px;
    background-color: #fff;
    border: 2px solid #005CA9;
    color: #005CA9;
    text-transform: uppercase;
    font-size: 1em;
    padding: 9px 18px;
    outline: none;
    font-weight: bold;
    margin-left: auto;
    margin-right: auto;
  }
  
  .vaildCheckIcon {
    color: #00C761;
  }

  .full-colum-content {
    color:#005CA9;
    font-weight: 300;
    font-family: 'Gotham Book';
    font-size: 12px;
    line-height: 18px;
    width: 169.5px;
    padding-left: 10px;
    padding-right: 10px;
  }
  
  .small-font {
    font-size: 0.7em;
  }

  .big-font {
    font-size: 1.2em;
  }
  
  .blue-font {
    color: #005CA9;
  }
  
  .small-padding {
    padding-top: 11px;
    padding-bottom: 11px;
  }

  .average-padding {
    padding-top: 18px;
    padding-bottom: 15px; 
  }

  .big-padding {
    padding-top: 20px;
    padding-bottom: 20px; 
  }

  .clean-row {
    border: none;
  }
  
  .flexibility {
    display: flex;
  }
  
  .width-stop {
    width: 163px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/booking/additionalServices/Details.vue